import { HeaderPresenter } from "./presenter";

const HeaderContainer: React.FC = () => {
  return <HeaderPresenter />;
};

export { HeaderContainer };
